export const checkInstancedArraysAvailability = () => {
    let webGL2available = false;
    let extensions = [];
    const canvas = document.createElement('canvas');
    try {
        webGL2available = !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));
    }
    catch (e) {
        webGL2available = false;
    }
    try {
        const renderingContext = canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl');
        if (renderingContext) {
            extensions = renderingContext.getSupportedExtensions();
        }
    }
    catch (e) {
        extensions = [];
    }
    if (canvas && canvas.remove)
        canvas.remove();
    return webGL2available || extensions.includes('ANGLE_instanced_arrays');
};
//# sourceMappingURL=instancedArrayCheck.js.map